import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { Button } from './ui/button';

interface ConfirmationModalProps {
  title: string;
  description?: string;
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
  confirmButtonVariant?: 'link' | 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | null | undefined;
  loading?: boolean;
  className?: string;
}

export function ConfirmationModal({
  title,
  description,
  onCancel,
  onConfirm,
  open,
  confirmButtonVariant,
  loading,
  className,
}: ConfirmationModalProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className={className}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={() => onCancel()}>
            Cancelar
          </Button>
          <Button variant={confirmButtonVariant} onClick={() => onConfirm()} disabled={loading}>
            {loading ? (
              <div className="flex items-center gap-2">
                <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                Processando...
              </div>
            ) : (
              'Confirmar'
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
